import { formatSvgStr } from "@/common/svg"
import { SimiulatorEquipment } from "@/types/equipment"
import React, { memo, useMemo } from "react"
import styles from './node.module.less'
import { Tooltip } from "antd"
import { useDnd } from "@antv/xflow"
import { createSvgNodeOption } from "../../nodes"
import { Equipment } from "@/services/project/equipment/equipment.model"
import { SvgElem } from "@/components/SvgElem/SvgElem"

interface MenuNodeProps {
  equipment: Equipment.Info
}

export const MenuNode = memo((props: MenuNodeProps) => {
  const { startDrag } = useDnd()
  const {equipment} = props;

  const image = useMemo(() => {
    return formatSvgStr(equipment.image, 'svg-node-icon')
  }, [equipment.image])

  const onDragStart = (e: React.MouseEvent<Element, MouseEvent>) => {
    startDrag(
      createSvgNodeOption(equipment as SimiulatorEquipment),
      e,
    )
  }

  return <div className={styles.nodeContainer} onMouseDown={onDragStart} draggable>
    <Tooltip title={equipment.name}>
      <div style={{width: '100%', height: '100%'}}><SvgElem imageStr={image} className={styles.nodeImg} /></div>
    </Tooltip>
  </div>
})
